import useApi from "../services/ApiService";
import {User} from "../models/User";
import { AxiosResponse } from "axios";
import { extractApiErrorMessage } from "@/lib/apiError";

export class AuthRepository {
  private api = useApi();
  
  async getTemporaryAccess(
    reason: string,
  ): Promise<User | null> {
    try {
      const response: AxiosResponse<User> = await this.api.post("/api/GrantOrganizationTemporaryAccess/", {
        reason: reason,
      });
      return response.data;
    } catch (error) {
      throw new Error(extractApiErrorMessage(error, "Failed to get temporary access."));
    }
  }
}

export default AuthRepository;
